import { Component } from '@angular/core';
import { FileManagerComponent } from '../../../components/pages/file-manager/file-manager.component';

@Component({
  selector: 'app-tech-file-manager',
  imports: [FileManagerComponent],
  templateUrl: './tech-file-manager.component.html',
  styleUrl: './tech-file-manager.component.scss'
})
export class TechFileManagerComponent {
  initialPath: string = 'tech';
}
